import { putPasswords } from "./ResetPassword.service";

export async function putPasswordsRepository(id, params) {
  const data = await putPasswords(id, params);
  if (data?.status === 204 || data?.status === 200) {
    return true;
  }
  if (typeof data === "object" && "statusText" in data) {
    return data.status === 204 || data.status === 200;
  }
  return false;
}
